import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    appContainer: {
        width: '100%',
        minHeight: '100vh',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        background: theme.palette.lightGrey.main,
        padding: '8rem 1rem 8rem',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('md')]: {
            padding: '8rem 7rem 8rem',
        },
    },
    appContainerFullScreenCalloutContainer: {
        width: '100vw',
        margin: '-3.5rem 0 2rem -1rem',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('md')]: {
            marginLeft: '-7rem',
        },
    },
    appContainerExternal: {
        background: '#ffffff',
        padding: '0',
    },
    ContainerContent: {
        padding: '1.5rem',
        background: '#ffffff',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0px 1px 18px rgba(221,225,236,0.6)',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up('sm')]: {
            padding: '2.5rem',
        },
    },
    ContainerContentExternal: {
        boxShadow: 'none',
        borderRadius: '0',
    },
    appContainerTitleContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginBottom: '3rem',
        gap: '1rem',
    },
    appContainerTitleTextContainer: {},
    appContainerTitleHcs: {
        fontSize: '.95rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.light,
    },
    appContainerTitle: {
        fontSize: '1.8rem',
        fontWeight: 800,
    },
    appContainerTitleGoBack: {
        background: '#ffffff',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        border: `1px solid ${theme.palette.lightGrey.half}`,
        boxShadow: '0px 1px 18px rgba(221,225,236,0.6)',
    },
}))
